import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import StyledPagination from './StyledPagination';

const PAGE_SIZE = 100;

export default function TicketPopupPagination({ offset, total, loadedCount, loading, onOffsetChange }: {
  offset: number; total: number | null; loadedCount: number; loading: boolean;
  onOffsetChange: (offset: number) => void;
}) {
  const page = Math.floor(offset / PAGE_SIZE) + 1;
  const pages = total ? Math.ceil(total / PAGE_SIZE) : 0;
  const range = loadedCount && total
    ? `Tickets ${(offset + 1).toLocaleString()}–${Math.min(offset + loadedCount, total).toLocaleString()} of ${total.toLocaleString()}`
    : total === 0 ? '0 tickets' : 'No tickets loaded';

  return <Box sx={{ px: 3, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
    <Stack spacing={0.25} role="status" aria-live="polite" aria-atomic="true">
      <Typography variant="body2">{loading ? 'Loading tickets…' : range}</Typography>
      {pages > 0 && <Typography variant="caption" color="text.secondary">Page {page.toLocaleString()} of {pages.toLocaleString()}</Typography>}
    </Stack>
    <StyledPagination aria-label="Ticket pages" count={Math.max(1, pages)} page={page}
      showFirstButton showLastButton disabled={loading || pages <= 1}
      onChange={(_event, nextPage) => onOffsetChange((nextPage - 1) * PAGE_SIZE)}
      sx={{ '& .MuiPagination-ul': { flexWrap: 'wrap', rowGap: 1 } }} />
  </Box>;
}
